/* eslint-disable no-nested-ternary */
import React from 'react';
import { Container } from './styled';
import { WarningMessageProps } from './types';
import { Icon } from '@/presentation/components';

const styledPropsDefault = {
  background: '#D5E5F0',
  iconSize: 20,
  fontSize: '14px',
  borderRadius: '8px',
  padding: '16px',
  alignItems: 'start',
  gap: '8px',
  textAlign: 'left'
};
const WarningMessage = ({
  message,
  styledProps = styledPropsDefault,
  iconName = 'info'
}: WarningMessageProps) => (
  <Container
    data-testid="cmp-warning-message"
    styleProps={{ ...styledPropsDefault, ...styledProps }}
  >
    <Icon name={iconName} size={styledProps?.iconSize ?? 24} />
    <span style={{ fontSize: styledProps?.fontSize ?? 14 }}>{message}</span>
  </Container>
);

export default WarningMessage;
